import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  forwardRef,
  Input,
  OnDestroy,
  OnInit,
  Renderer2,
  inject
} from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { Store } from '@ngrx/store';
import { cloneDeep } from 'lodash-es';
import { AutoUnsubscribe } from 'ngx-auto-unsubscribe';
import { Subscription } from 'rxjs';
import { rolesTable } from 'src/app/STORE/selectors/roles.selector';
@AutoUnsubscribe()
@Component({
  selector: 'vb-role-lookup',
  templateUrl: './role-lookup.component.html',
  styleUrls: ['./role-lookup.component.scss'],
  changeDetection: ChangeDetectionStrategy.Default,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => RoleLookupComponent),
      multi: true
    }
  ],
  standalone: false  //NOSONAR
})
export class RoleLookupComponent implements OnInit, OnDestroy {
  private renderer = inject(Renderer2);
  private elementRef = inject(ElementRef);
  private store = inject(Store);
  private changeDetector = inject(ChangeDetectorRef);

  @Input() element: any;
  @Input() disableField = false;
  private modelValue: any;
  protected onTouched: () => void;
  protected onChange: (value: number) => void;
  disabled: boolean;
  rolesSub = new Subscription();

  roleSelection: any = '';
  allRoles: any = [];
  selectedRoles: any;

  get model() {
    return this.modelValue;
  }

  writeValue(value: any): void {
    this.setSelectedRoles(value);
    this.modelValue = value;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  set(value: any) {
    this.modelValue = value;
    this.onChange(this.modelValue);
    this.onTouched();
    this.changeDetector.markForCheck();
  }

  setDisabledState(isDisabled: boolean) {
    this.renderer.setProperty(this.elementRef.nativeElement, 'disabled', isDisabled);
    this.disabled = isDisabled;
  }

  getAllRoles() {
    this.rolesSub = this.store.select(rolesTable).subscribe((allTables: any) => {
      if (allTables) {
        this.allRoles = cloneDeep(allTables.rolesTable);
      }
    });
  }

  handleCheckboxChange(e) {
    this.modelValue = this.selectedRoles.length ? this.selectedRoles : ['all'];
    if (this.selectedRoles.length === 0) {
      this.roleSelection = 'all';
    }
    this.onChange(this.modelValue);
  }

  // send api call if all is selected and make selected roles empty
  handleRoleTypeChange(event) {
    this.selectedRoles = [];
    if (this.roleSelection !== 'all') {
      this.selectedRoles = this.allRoles
        .filter((item) => item?.shortName?.toLowerCase() === 'app admin')
        .map((fld) => {
          return fld.sid;
        });
    } else {
      this.roleSelection = null;
      setTimeout(() => {
        this.roleSelection = 'all';
        this.selectedRoles = ['all'];
      }, 0);
    }
    setTimeout(() => {
      this.onTouched();
      this.modelValue = this.selectedRoles.length ? this.selectedRoles : ['all'];
      this.onChange(this.modelValue);
      this.changeDetector.markForCheck();
    }, 0);
  }

  setSelectedRoles(value) {
    if (value?.length && value?.[0] !== 'all') {
      this.roleSelection = 'selected';
      this.selectedRoles = value;
    } else if (value?.length && value?.[0] === 'all') {
      this.roleSelection = 'all';
    }
  }

  ngOnInit(): void {
    this.getAllRoles();
  }

  ngOnDestroy(): void {
    if ($(this.elementRef.nativeElement)) {
      $(this.elementRef.nativeElement).remove();
    }
  }
}
